module.exports = __webpack_public_path__ + "img/quizz-step-10-3.fea06be0.jpg";